import { render, staticRenderFns } from "./InfosetsMemberActionsMenu.container.vue?vue&type=template&id=332c34cf&scoped=true&"
import script from "./InfosetsMemberActionsMenu.container.vue?vue&type=script&lang=ts&"
export * from "./InfosetsMemberActionsMenu.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c34cf",
  null
  
)

export default component.exports